import { styled } from '@mui/material/styles';

export const StyledTopBarContainer = styled('div')`
  .MuiGrid-root.MuiGrid-container {
    padding: 0;
    border-top: none;
    border-bottom: none;
    background-color: transparent;
  }
`;
